export const reviewPageES =  {
	title: "Deja una reseña",
	placeholder: "Comparte tu experiencia...",
	anonymous: "Enviar esta reseña de forma anónima",
	submit: "Enviar reseña",
	submitting: "Enviando..."
}
